// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dAeo","placeholdersHeader":"styles_placeholdersHeader__1kyGy","editorStyle":"styles_editorStyle__2Hzms","placeholdersBox":"styles_placeholdersBox__KOkY_"};